import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useTranslation } from "@/i18n/I18nProvider";
import { SPRING_MODAL } from "@/lib/motion";

/**
 * Passive-dwell conversion toast — transparent about the auto-check-in and
 * a one-tap route to rate it.
 */
export function GeoVisitToast({
  toast,
  onLeaveFeedback,
  onDismiss,
}: {
  toast: { visitId: number; name: string } | null;
  onLeaveFeedback: () => void;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();
  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          key="geo-visit-toast"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={SPRING_MODAL}
          className="fixed inset-x-3 z-[115] mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-white/15 light:border-black/15 bg-zinc-950/95 light:bg-white/95 px-4 py-3 shadow-[0_0_0_1px_#000,0_20px_40px_-24px_#000] backdrop-blur sm:inset-x-auto sm:right-5"
          style={{ bottom: "max(0.75rem, env(safe-area-inset-bottom, 0px))" }}
          role="status"
        >
          <p className="min-w-0 flex-1 text-sm text-zinc-200 light:text-zinc-800">
            {t("GEO_VISIT_TOAST", { venue: toast.name })}
          </p>
          <button
            type="button"
            onClick={onLeaveFeedback}
            className="shrink-0 rounded-lg bg-paper light:bg-ink px-3 py-1.5 text-xs font-semibold text-ink light:text-paper transition hover:bg-white light:hover:bg-zinc-800"
          >
            {t("DINE_IN_LEAVE_FEEDBACK")}
          </button>
          <button
            type="button"
            onClick={onDismiss}
            aria-label={t("CLOSE")}
            className="grid h-8 w-8 shrink-0 place-items-center rounded-full border border-white/15 light:border-black/15 text-zinc-400 light:text-zinc-600 transition hover:border-white/40 light:hover:border-black/35 hover:text-zinc-100 light:hover:text-zinc-900"
          >
            <X className="h-4 w-4" aria-hidden />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
